'use client';

import { useState, useEffect } from 'react';

interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="flex flex-wrap gap-sm mb-xl">
        {categories.map((category) => (
          <button
            key={category}
            className={`px-md py-sm text-sm font-normal tracking-wide transition-all duration-base border ${
              category === activeCategory
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-background text-text-primary border-border hover:border-primary'
            }`}
          >
            {category}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-sm mb-xl">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-md py-sm text-sm font-normal tracking-wide transition-all duration-base border ${
            category === activeCategory
              ? 'bg-primary text-primary-foreground border-primary'
              : 'bg-background text-text-primary border-border hover:border-primary'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;